<template>
  <div class="to-top" @click="clickToTop">
    <img class="to-top-img" src="@/assets/images/to-top.png" alt="返回顶部" />
  </div>
</template>

<script setup lang="ts">
const emits = defineEmits<{ backToTop: [] }>();
const clickToTop = () => {
  emits('backToTop');
};
defineOptions({
  name: 'ToTop',
});
</script>
<style lang="scss" scoped>
.to-top {
  position: fixed;
  right: 10px;
  bottom: 5vh;
  z-index: 1000;
  width: 40px;
  height: 40px;
  padding: 10px;
  background-color: rgb(0 0 0 / 60%);
  border-radius: 50%;
  opacity: 0.7;

  .to-top-img {
    width: 100%;
    height: 100%;
  }
}
</style>
